const calculateIsUnder16 = (dob: string | Date): boolean => {
  if (!dob) return false

  const dobDate = new Date(dob)
  const today = new Date()

  // Calculate age considering both year and month
  let age = today.getFullYear() - dobDate.getFullYear()

  // Adjust age if birthday hasn't occurred yet this year
  if (
    today.getMonth() < dobDate.getMonth() ||
    (today.getMonth() === dobDate.getMonth() && today.getDate() < dobDate.getDate())
  ) {
    age--
  }

  return age < 16
}

export default calculateIsUnder16
